!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["React-OpenIdConnect"] = t() : e["React-OpenIdConnect"] = t();
}("undefined" != typeof self ? self : this, function () {
  return webpackJsonpReact_OpenIdConnect([1], {
    2: function _(e, t, n) {
      "use strict";

      function i(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function r(e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }

      function o(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var s = n(3),
          a = n.n(s),
          u = n(7),
          c = n.n(u),
          d = n(10),
          l = (n.n(d), function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }

        return function (t, n, i) {
          return n && e(t.prototype, n), i && e(t, i), t;
        };
      }()),
          f = function (e) {
        function t(e) {
          i(this, t);
          var n = r(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.signin = n.signin.bind(n), n.onUserLoaded = n.onUserLoaded.bind(n), n.state = {
            isAuthenticated: !1
          }, n;
        }

        return o(t, e), l(t, [{
          key: "componentWillMount",
          value: function value() {
            var e = this;
            this.userManager = new d.UserManager(this.props.OidcSettings), this.userManager.events.addUserLoaded(this.onUserLoaded), this.userManager.events.addUserUnloaded(this.onUserUnloaded), this.userManager.getUser().then(function (t) {
              null !== t && void 0 !== t ? e.onUserLoaded(t) : window.location.href.includes("#id_token") && e.userManager.signinRedirectCallback().then(function () {
                window.history.replaceState({}, "", "/");
              }).catch(function (e) {
                console.log("Error signinRedirectCallback: ", e);
              });
            });
          }
        }, {
          key: "onUserLoaded",
          value: function value(e) {
            this.setState({
              isAuthenticated: !0
            }), this.props.userLoaded(e);
          }
        }, {
          key: "onUserUnloaded",
          value: function value() {
            this.setState({
              isAuthenticated: !1
            }), this.props.userUnLoaded();
          }
        }, {
          key: "signin",
          value: function value() {
            this.userManager.signinRedirect().then(function () {
              console.log("signinRedirect ok");
            }).catch(function (e) {
              console.log("signinRedirect error:", e);
            });
          }
        }, {
          key: "render",
          value: function value() {
            return this.state.isAuthenticated ? this.props.children : a.a.createElement("div", {
              onClick: this.signin
            }, this.props.renderNotAuthenticated());
          }
        }]), t;
      }(s.Component);

      f.defaultProps = {
        OidcSettings: {},
        userUnLoaded: null,
        userLoaded: null,
        renderNotAuthenticated: null
      }, f.propTypes = {
        OidcSettings: c.a.shape({
          authority: c.a.string.isRequired,
          client_id: c.a.string.isRequired,
          redirect_uri: c.a.string.isRequired,
          post_logout_redirect_uri: c.a.string.isRequired,
          response_type: c.a.string.isRequired,
          scope: c.a.string.isRequired
        }).isRequired,
        userLoaded: c.a.func,
        userUnLoaded: c.a.func,
        renderNotAuthenticated: c.a.func.isRequired
      }, t.default = f;
    }
  }, [2]);
});